import React from 'react';
import RadioGroup from '@mui/material/RadioGroup';

export default function CustomizedRadioGroup(props) {
    const { children, value, ...rest } = props;
    return (
        <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            // sx={{ ml: 1 }}
            value={value}
            {...rest}
        >
            {children}
        </RadioGroup>
    );
}